import * as React from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";

import type { SimulationSummaryData, OutputTableData } from "../../../../../../../server/models/ad-copy/output";
import { TextRed } from "../../../../parts/font";
import { AdCopyReportTitle } from "../parts/report-title";
import { OutputTbody } from "./output-tbody";
import { OutputThead } from "./output-thead";
import { array2CsvBlob, downloadData } from "../../../../../lib/data";
import { AdCopyJob } from "../../../../../../../server/models/ad-copy/job";
import { makeSimulationSummaryCSVData } from "../../../../../../../server/lib/ad-copy/common";
import { AdCopyActivity } from "../../../../../../../server/models/ad-copy/activity";

const ButtonArea = styled.div`
	button {
		margin: 0px 10px;
	}
`;

const StyledTable = styled.table`
	td,
	th {
		border: 1px dotted #888;
		padding: 3px;
	}

	td {
		min-width: 6rem;
	}
`;

type Props = {
	activity: AdCopyActivity;
	differentiationAndONS: OutputTableData;
	simulationSummary: SimulationSummaryData | undefined;
	job: AdCopyJob;
	navigateSimulationPage: () => void;
	simulations: OutputTableData | undefined;
};

export const AdCopyResultSummary = React.memo((props: Props) => {
	const { activity, differentiationAndONS, job, navigateSimulationPage, simulationSummary, simulations } = props;

	const onDownload = React.useCallback(() => {
		if (simulationSummary == null) {
			return;
		}

		const tmp = makeSimulationSummaryCSVData(activity, job, simulationSummary);
		const blob = array2CsvBlob(tmp);
		downloadData(blob, `${job.jobNum}-シミュレーションサマリー.csv`);
	}, [activity, job, simulationSummary]);

	return (
		<>
			<AdCopyReportTitle>結果サマリー</AdCopyReportTitle>

			{simulations != null && (
				<>
					<ButtonArea>
						<Button onClick={onDownload} size={"sm"} variant={"outline-secondary"}>
							Download
						</Button>
						<Button onClick={navigateSimulationPage} size="sm" variant="outline-secondary">
							補整＆提案フォーマット
						</Button>
					</ButtonArea>
					<br />
					<p className="mt-1">
						<TextRed>※年間購買個数の数値は変数補整前の初期値</TextRed>
					</p>
				</>
			)}

			<StyledTable>
				{/* 需要予測 */}
				{simulations != null && (
					<>
						<OutputThead data={simulations.tHead} />

						{simulations.tBodies.map((tBody, i) => (
							<OutputTbody key={i} data={tBody} />
						))}
					</>
				)}

				{/* 差別性等 */}
				<OutputThead data={differentiationAndONS.tHead} />

				{differentiationAndONS.tBodies.map((tBody, i) => (
					<OutputTbody key={i} data={tBody} />
				))}
			</StyledTable>
		</>
	);
});
